export interface CreateWhatsappLogin {
  countryCallingCode: string;
  mobileNumber: string;
  deliveryMethod?: 'whatsapp' | 'sms';
}

export interface WhatsappLogin {
  requestId: string;
  mobileNumber: string;
  expires: number;
}

export interface InitialState {
  data: WhatsappLogin;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: {
    requestId: '',
    mobileNumber: '',
    expires: 0
  },
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
